"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatDate = formatDate;
exports.getYesterday = getYesterday;
exports.getYesterdayEnd = getYesterdayEnd;
exports.getTodayBegin = getTodayBegin;
exports.getNowLessOneSecond = getNowLessOneSecond;
exports.getPastTenDayBegin = getPastTenDayBegin;
exports.getPastTenDayEnd = getPastTenDayEnd;
exports.getMonBegin = getMonBegin;
exports.getPreviousMonBegin = getPreviousMonBegin;
exports.getPreviousMonEnd = getPreviousMonEnd;
exports.getToday = getToday;
exports.getTodayEarlyMorning = getTodayEarlyMorning;

require("core-js/modules/es6.regexp.constructor");

require("core-js/modules/es6.regexp.replace");

function formatDate(date, fmt) {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }

  var o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  };

  for (var k in o) {
    if (new RegExp("(".concat(k, ")")).test(fmt)) {
      var str = o[k] + '';
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str));
    }
  }

  return fmt;
}

;

function getYesterday() {
  var date = new Date();
  var fmt = "yyyy-MM-dd hh:mm:ss";

  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }

  var o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate() - 1,
    'h+': "00",
    'm+': "00",
    's+': "00"
  };

  for (var k in o) {
    if (new RegExp("(".concat(k, ")")).test(fmt)) {
      var str = o[k] + '';
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str));
    }
  }

  return fmt;
}

function getYesterdayEnd() {
  var date = new Date();
  var fmt = "yyyy-MM-dd hh:mm:ss";

  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }

  var o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate() - 1,
    'h+': "23",
    'm+': "59",
    's+': "59"
  };

  for (var k in o) {
    if (new RegExp("(".concat(k, ")")).test(fmt)) {
      var str = o[k] + '';
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str));
    }
  }

  return fmt;
}

function getTodayBegin() {
  var date = new Date();
  var fmt = "yyyy-MM-dd hh:mm:ss";

  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }

  var o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': "00",
    'm+': "00",
    's+': "00"
  };

  for (var k in o) {
    if (new RegExp("(".concat(k, ")")).test(fmt)) {
      var str = o[k] + '';
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str));
    }
  }

  return fmt;
}

function getNowLessOneSecond() {
  var date = new Date();
  var fmt = "yyyy-MM-dd hh:mm:ss";

  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }

  var o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    // 'h+': date.getHours(),
    // 'm+': date.getMinutes(),
    // 's+': date.getSeconds() - 1,
    'h+': "23",
    'm+': "59",
    's+': "59"
  };

  for (var k in o) {
    if (new RegExp("(".concat(k, ")")).test(fmt)) {
      var str = o[k] + '';
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str));
    }
  }

  return fmt;
}

function getPastTenDayBegin() {
  var today = new Date();
  var lastTenDay = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 10, 0, 0, 0);
  var fmt = "yyyy-MM-dd hh:mm:ss";

  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (lastTenDay.getFullYear() + '').substr(4 - RegExp.$1.length));
  }

  var o = {
    'M+': lastTenDay.getMonth() + 1,
    'd+': lastTenDay.getDate(),
    'h+': '00',
    'm+': '00',
    's+': '00'
  };

  for (var k in o) {
    if (new RegExp("(".concat(k, ")")).test(fmt)) {
      var str = o[k] + '';
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str));
    }
  }

  return fmt;
}

function getPastTenDayEnd() {
  var today = new Date();
  var lastTenDay = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 10, 23, 59, 59);
  var fmt = "yyyy-MM-dd hh:mm:ss";

  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (lastTenDay.getFullYear() + '').substr(4 - RegExp.$1.length));
  }

  var o = {
    'M+': lastTenDay.getMonth() + 1,
    'd+': lastTenDay.getDate(),
    'h+': "23",
    'm+': "59",
    's+': "59"
  };

  for (var k in o) {
    if (new RegExp("(".concat(k, ")")).test(fmt)) {
      var str = o[k] + '';
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str));
    }
  }

  return fmt;
} // export function getLastTenDayBegin(){
//   let today = new Date();
//   let lastTenDay = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 10, 0,0,0);
//   // return lastTenDay;
//   let fmt = "yyyy-MM-dd hh:mm:ss";
//   if (/(y+)/.test(fmt)) {
//     fmt = fmt.replace(RegExp.$1, (lastTenDay.getFullYear() + '').substr(4 - RegExp.$1.length));
//   }
//   let o = {
//     'M+': lastTenDay.getMonth()+1,
//     'd+': lastTenDay.getDate(),
//     'h+': '00',
//     'm+': '00',
//     's+': '00',
//   };
//   for (let k in o) {
//     if (new RegExp(`(${k})`).test(fmt)) {
//       let str = o[k] + '';
//       fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str));
//     }
//   }
//   return fmt;
// }


function getMonBegin() {
  var date = new Date();
  var fmt = "yyyy-MM-dd hh:mm:ss";

  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }

  var o = {
    'M+': date.getMonth() + 1,
    'd+': '01',
    'h+': '00',
    'm+': '00',
    's+': '00'
  };

  for (var k in o) {
    if (new RegExp("(".concat(k, ")")).test(fmt)) {
      var str = o[k] + '';
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str));
    }
  }

  return fmt;
}

function getPreviousMonBegin() {
  var date = new Date();
  var fmt = "yyyy-MM-dd hh:mm:ss";

  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }

  var o = {
    'M+': date.getMonth(),
    'd+': '01',
    'h+': '00',
    'm+': '00',
    's+': '00'
  };

  for (var k in o) {
    if (new RegExp("(".concat(k, ")")).test(fmt)) {
      var str = o[k] + '';
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str));
    }
  }

  return fmt;
}

function getPreviousMonEnd() {
  var date = new Date();
  var fmt = "yyyy-MM-dd hh:mm:ss";

  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }

  var o = {
    'M+': date.getMonth() + 1,
    'd+': '00',
    'h+': '23',
    'm+': '59',
    's+': '59'
  };

  for (var k in o) {
    if (new RegExp("(".concat(k, ")")).test(fmt)) {
      var str = o[k] + '';
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str));
    }
  }

  return fmt;
}

function getToday() {
  var date = new Date();
  var fmt = "yyyy-MM-dd hh:mm:ss";

  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }

  var o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': "23",
    'm+': "59",
    's+': "59"
  };

  for (var k in o) {
    if (new RegExp("(".concat(k, ")")).test(fmt)) {
      var str = o[k] + '';
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str));
    }
  }

  return fmt;
}

function getTodayEarlyMorning() {
  var time = new Date();
  time.setHours(0);
  time.setMinutes(0);
  time.setSeconds(0);
  time.setMilliseconds(0);
  return time;
}

function padLeftZero(str) {
  return ('00' + str).substr(str.length);
}